import { useState } from 'react';
import { Box, HStack } from '@chakra-ui/react';
import type { Editor } from '@tiptap/core';
import { BubbleMenu } from '@tiptap/react';
import { AlignCenter, AlignLeft, AlignRight, Scaling, Trash2 } from 'lucide-react';
import { FormatButton } from './FormatButton';

const widths = ['40%', '60%', '80%'] as const;

export function ImageBubbleMenu({ editor }: { editor: Editor | null }) {
  const [width, setWidth] = useState<(typeof widths)[number]>(widths[0]);

  if (!editor || !editor.isEditable) {
    return null;
  }

  const handleResize = () => {
    const nextIndex = (widths.indexOf(width) + 1) % widths.length;
    setWidth((prev) => widths[nextIndex] ?? prev);
    editor.commands.updateAttributes('image', { width: widths[nextIndex] });
  };

  return (
    <BubbleMenu
      editor={editor}
      tippyOptions={{
        placement: 'top',
        offset: [0, 10],
      }}
      shouldShow={() => editor.isActive('image')}
    >
      <HStack
        gap={0.5}
        bg="bg.surface"
        shadow="sm"
        outline="1px"
        p={0.5}
        borderRadius="md"
        borderWidth="1px"
        boxShadow="sm"
      >
        <FormatButton
          label="align left"
          aria-label="align left"
          icon={AlignLeft}
          onClick={() => editor.commands.setTextAlign('left')}
          isActive={editor.isActive({ textAlign: 'left' })}
        />
        <FormatButton
          label="align center"
          aria-label="align center"
          icon={AlignCenter}
          onClick={() => editor.commands.setTextAlign('center')}
          isActive={editor.isActive({ textAlign: 'center' })}
        />
        <FormatButton
          label="align right"
          aria-label="align right"
          icon={AlignRight}
          onClick={() => editor.commands.setTextAlign('right')}
          isActive={editor.isActive({ textAlign: 'right' })}
        />
        <Box bgColor="border.default" h="32px" w="2px" />
        <FormatButton
          label="resize image"
          aria-label="resize image"
          icon={Scaling}
          onClick={handleResize}
          isActive={false}
        />
        <FormatButton
          label="delete image"
          aria-label="delete image"
          icon={Trash2}
          onClick={() => editor.commands.deleteSelection()}
          isActive={false}
        />
      </HStack>
    </BubbleMenu>
  );
}
